// extracted by mini-css-extract-plugin
module.exports = {"editIcon":"Terms-module__editIcon___aLKWu","termsWrapper":"Terms-module__termsWrapper___oPKCT","separator":"Terms-module__separator___LeszF"};